<template>
  <div>
    <b-field label="Shipping Account Nickname">
      <b-input v-model="form.nickname" size="is-medium" placeholder="e.g. My FedEx Account" @input="announce" />
    </b-field>
    <b-field label="FedEx Account Number">
      <b-input v-model="form.account_number" size="is-medium" @input="announce" />
    </b-field>
    <b-field label="Description">
      <b-input v-model="form.description" size="is-medium" @input="announce" />
    </b-field>
    <!-- Shipping Address -->
    <p class="has-text-weight-bold mb-sm has-text-info border-b pb-sm">Shipping Address</p>
    <div class="columns is-multiline">
      <div class="column is-full">
        <b-field label="Street">
          <b-input v-model="form.shipping_address.street1" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="City">
          <b-input v-model="form.shipping_address.city" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="State">
          <b-input v-model="form.shipping_address.state" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Zip">
          <b-input v-model="form.shipping_address.zip" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Country">
          <b-input v-model="form.shipping_address.country" size="is-medium" placeholder="e.g. US" maxlength="3" @input="announce" />
        </b-field>
      </div>
    </div>
    <!-- Corporate Contact -->
    <p class="has-text-weight-bold mb-sm mt-md has-text-info border-b pb-sm">Corporate Contact</p>
    <div class="columns is-multiline">
      <div class="column is-half">
        <b-field label="First Name">
          <b-input v-model="form.corporate_contact.first_name" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Last Name">
          <b-input v-model="form.corporate_contact.last_name" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Job Title">
          <b-input v-model="form.corporate_contact.job_title" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Company Name">
          <b-input v-model="form.corporate_contact.company_name" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Phone Number">
          <b-input v-model="form.corporate_contact.phone_number" size="is-medium" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Email Address">
          <b-input v-model="form.corporate_contact.email_address" type="email" size="is-medium" @input="announce" />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        nickname: null,
        account_number: null,
        description: null,
        shipping_address: {
          street1: null,
          city: null,
          state: null,
          zip: null,
          country: null
        },
        corporate_contact: {
          first_name: null,
          last_name: null,
          job_title: null,
          company_name: null,
          phone_number: null,
          email_address: null
        }
      }
    }
  },
  computed: {
    valid () {
      const address = this.form.shipping_address
      const contact = this.form.corporate_contact
      return !!(
        this.form.nickname &&
        this.form.account_number &&
        this.form.description &&
        address.street1 && address.city && address.state && address.zip && address.country &&
        contact.first_name && contact.last_name && contact.job_title && contact.company_name && contact.phone_number && contact.email_address
      )
    }
  },
  methods: {
    announce () {
      this.$emit('input', this.valid ? this.form : null)
    }
  }
}
</script>
